export const getBonusHistory = async (sellerId, clientId) => {

    let url

    if (sellerId === '6E38B19A-B5C3-4E54-83A7-9A75FE7B73F5') {
        url = `https://elcity.maxbonus.ru/cloud/service.php?class=CHATBOT&action=OPERATIONSHISTORY&seller_id=${sellerId}&s_token=${clientId}`;
    } else {
        url = `https://cabinet.maxbonus.ru/cloud/service.php?class=CHATBOT&action=OPERATIONSHISTORY&seller_id=${sellerId}&s_token=${clientId}`;
    }

    try {
        const response = await fetch(url);
        const data = await response.json();
        return data.result;
    } catch (error) {
        console.error("Ошибка при получении данных:", error);
        return [];
    }
};

export const getSalesHistory = async (sellerId, clientId) => {

    let url

    if (sellerId === '6E38B19A-B5C3-4E54-83A7-9A75FE7B73F5') {
        url = `https://elcity.maxbonus.ru/cloud/service.php?class=CHATBOT&action=SALESHISTORY&seller_id=${sellerId}&s_token=${clientId}`;
    } else {
        url = `https://cabinet.maxbonus.ru/cloud/service.php?class=CHATBOT&action=SALESHISTORY&seller_id=${sellerId}&s_token=${clientId}`;
    }

    try {
        const response = await fetch(url);
        const data = await response.json();
        return data.result;
    } catch (error) {
        console.error("Ошибка при получении данных:", error);
        return [];
    }
};

export const updateRatingCheck = async (sellerId, clientId, sale, rating) => {
    let url;

    if (sellerId === '6E38B19A-B5C3-4E54-83A7-9A75FE7B73F5') {
        url = `https://elcity.maxbonus.ru/cloud/service.php?class=CHATBOT&action=UPDATERATING&seller_id=${sellerId}&s_token=${clientId}&sale_id=${sale.s_check}&rating=${rating}`;
    } else {
        url = `https://cabinet.maxbonus.ru/cloud/service.php?class=CHATBOT&action=UPDATERATING&seller_id=${sellerId}&s_token=${clientId}&sale_id=${sale.s_check}&rating=${rating}`;
    }

    try {
        const response = await fetch(url, {
            method: 'POST',
        });
        return response;
    } catch (error) {
        console.error("Ошибка при отправке данных:", error);
        return { status: 500 };
    }
};

export const getCheckDetail = async (sellerId, clientId,checkId) => {

    let url

    if (sellerId === '6E38B19A-B5C3-4E54-83A7-9A75FE7B73F5') {
        url = `https://elcity.maxbonus.ru/cloud/service.php?class=CHATBOT&action=CHECKDETAIL&seller_id=${sellerId}&s_token=${clientId}&check_id=${checkId}`;
    } else {
        url = `https://cabinet.maxbonus.ru/cloud/service.php?class=CHATBOT&action=CHECKDETAIL&seller_id=${sellerId}&s_token=${clientId}&check_id=${checkId}`;
    }

    try {
        const response = await fetch(url);
        const data = await response.json();
        return data.result;
    } catch (error) {
        console.error("Ошибка при получении данных:", error);
        return [];
    }
};